import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-number-input";
import {
  useElements,
  Elements,
  CardElement,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Magic } from "magic-sdk";
// import { OAuthExtension } from "@magic-ext/oauth";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";
import { useAccount } from "wagmi";
import { useSigner } from "wagmi";
import { SubscriptionAddress } from "./Contracts/Subscription";
import { SubscriptionAbi } from "./Contracts/Subscription";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";

import { ConnectExtension } from "@magic-ext/connect";
import Loading from "./Loading";
import TermsnConditions from "./TermsnConditions";
import { BsCheckAll } from "react-icons/bs";
import { RxCross1 } from "react-icons/rx";

const magicKey = process.env.REACT_APP_MAGIC_PUBLISHABLE_KEY || "";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const privateKey = process.env.REACT_APP_ADMIN_PRIVATEkEY;
const NODE_URL = process.env.REACT_APP_NODE_URL;

const Fiat = (props) => {
  const navigate = useNavigate();
  const { BigNumber } = require("ethers");
  const { address } = useAccount();
  // const { data: signer } = useSigner();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState();
  const [OTP, setOTP] = useState("");
  const [OTPSent, setOTPSent] = useState(false);
  const [OTPVerified, setOTPVerified] = useState(false);
  const [magic, setMagic] = useState(null);

  const [payment, setPayment] = useState("1000");
  const [magic1, setMagic1] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const plan = localStorage.getItem("plan");
  const packages = localStorage.getItem("package");
  console.log("Fiat plan", plan);
  console.log("Fiat package", packages);

  const [showTermsModal, setShowTermsModal] = useState(false);
  const [checkTerms, setCheckTerms] = useState(false);

  const openTermsModal = () => {
    showTermsModal ? setShowTermsModal(false) : setShowTermsModal(true);
  };

  const checkTermsHandel = () => {
    checkTerms ? setCheckTerms(false) : setCheckTerms(true);
  };
  // let contract;
  // if (signer) {
  //   contract = new ethers.Contract(
  //     SubscriptionAddress,
  //     SubscriptionAbi,
  //     signer
  //   );
  // }
  useEffect(() => {
    if (localStorage.getItem("package") == 0) {
      setPayment(400);
    } else if (localStorage.getItem("package") == 1) {
      setPayment(800);
    } else if (localStorage.getItem("package") == 2) {
      setPayment(1000);
    }

    const networks = {
      rpcUrl: "https://rpc-mumbai.maticvigil.com/",
      chainId: 80001,
    };
    const magic2 = new Magic(magicKey, {
      network: networks,
      extensions: [new ConnectExtension()],
      // extensions: [new OAuthExtension()]
    });
    setMagic(magic2);
  }, []);

  // console.log("magicccccccccccccc",magic)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Create a payment intent on the backend
      const provider = new ethers.providers.JsonRpcProvider(NODE_URL);
      const magicProvider = new ethers.providers.Web3Provider(
        magic.rpcProvider
      );
      const magicSigner = magicProvider.getSigner();
      const signer = new ethers.Wallet(privateKey, provider);
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/create-payment-intent`,
        {
          amount: payment,
          name: name,
          email: email,
          phone: phone,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const id = response.data.id;
      console.log("id", id);
      console.log("res", response.data.msg);
      toast.success("Success: " + response.data.msg);
      const clientSecret = response.data.clientSecret;
      console.log("secrete", clientSecret);
      console.log("stripe", stripe);

      // Use Stripe to complete the payment
      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
          billing_details: {
            name,
            email,
            phone,
          },
        },
      });

      console.log("Resulttttttttttttttttt", result);
      if (result.error) {
        console.log(result.error.message);
        setIsLoading(false);
      } else {
        let didToken = await magic?.auth.loginWithEmailOTP({ email });
        if (didToken) {
          const userMetadata = await magic.user.getMetadata();
          console.log("acount", userMetadata.publicAddress);
          const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/magic-acount`,
            {
              email: email,
              phone: phone,
              walletAddress: userMetadata.publicAddress,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          console.log("1st Post", response);
          const tx = {
            from: signer.getAddress(),
            to: magicSigner.getAddress(),
            value: ethers.utils.parseEther("0.05"),
            // value: 100000,
          };
          signer.sendTransaction(tx).then(async (transaction) => {
            console.log(transaction);
            transaction.wait().then(async (res) => {
              let contractt = new ethers.Contract(
                SubscriptionAddress,
                SubscriptionAbi,
                magicSigner
              );
              await contractt
                .subscribe(packages, { value: plan })
                .then((tx) =>
                  tx.wait().then(async (res) => {
                    await axios.post(
                      `${process.env.REACT_APP_SERVER_URL}/save-payment`,
                      {
                        pId: result.paymentIntent.id,
                        userId: id,
                        boxAddress: res.events[1].address,
                        doller: payment / 100,
                      }
                    );

                    axios
                      .post(
                        `${process.env.REACT_APP_SERVER_URL}/subscription`,
                        {
                          subscription: `This subscription is buy in ${plan}`,
                          address: res.events[1].address,
                          id: id,
                          payment: 0,
                          subType:
                            packages == 0
                              ? "small"
                              : packages == 1
                              ? "medium"
                              : "large",
                        },
                        {
                          headers: {
                            "Content-Type": "application/json",
                          },
                        }
                      )
                      .then(async (res) => {
                        console.log("2nd Post", res);

                        localStorage.setItem(
                          "userData",
                          JSON.stringify(res?.data?.user)
                        );
                        console.log(res?.data);
                        localStorage.setItem("token", res?.data?.Token);
                        // localStorage.setItem("isMagic", true);
                        setIsLoading(false);
                        // localStorage.setItem("magicAddress", await magicSigner.getAddress());
                        navigate("/creator");
                      });
                  })
                )
                .catch((err) => {
                  toast.error(err.message);
                  setIsLoading(false);
                });
            });
          });
        }
        console.log(result.paymentIntent);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const generateOTP = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/phone-otp-request`,
        { number: phone }
      );
      if (res.data.success) {
        console.log("Successfuly ", res.data);

        toast("Success Use this OTP : " + res?.data?.otp, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setOTPSent(true);

        // alert("Success Use this OTP : "+res?.data?.otp)
      } else {
        console.log("error ", res.data.msg);
        toast(res.data.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setOTPSent(false);

        // alert(res.data.msg)
      }
    } catch (error) {
      toast("Error logging in:", error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      // console.error('Error logging in:', error);
    }
  };
  const verifyOTP = async (otp) => {
    console.log(otp);
    const res = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/verify-phone-request`,
      { number: phone, otpCode: otp }
    );
    console.log(res);
    if (res.data.success) {
      console.log("Successfuly ", res.data);
      setOTPVerified(true);
    } else {
      setOTPVerified(false);
      toast.error("Please try again after some time.");
    }
  };
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <div
        className="relative z-50 px-8"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur transition-opacity"></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-2 text-center sm:items-center sm:p-0">
            <div className="relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] rounded-lg shadow dark:bg-gray-700 py-2">
              <div className="bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] p-2">
                <div className="sm:flex sm:items-start">
                  <div className="px-2">
                    <h3 className="mb-2 text-xl font-medium text-white dark:text-white">
                      Easy Register & Box Purchase
                    </h3>
                    <form
                      className={`space-y-6 ${isLoading ? " blur-xl " : ""}`}
                      onSubmit={handleSubmit}
                    >
                      <div>
                        <label
                          htmlFor="email"
                          className="block mb-2 text-sm text-left font-medium text-white dark:text-white"
                        >
                          Enter Email
                        </label>
                        <input
                          type="email"
                          onChange={(e) => setEmail(e.target.value)}
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                          placeholder="Email"
                          required
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="password"
                          className="block mb-2 text-sm text-left font-medium text-white dark:text-white"
                        >
                          User Name
                        </label>
                        <input
                          type="text"
                          onChange={(e) => setName(e.target.value)}
                          placeholder="Username"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                          required
                        />
                      </div>
                      <div className="relative">
                        <label className="block mb-2 text-sm text-left font-medium text-white dark:text-white">
                          Enter Phone No
                        </label>
                        <PhoneInput
                          international
                          countryCallingCodeEditable={false}
                          defaultCountry="US"
                          onChange={setPhone}
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        />
                        <div
                          onClick={generateOTP}
                          className={`cursor-pointer absolute bottom-5 right-4 ${
                            !OTPSent ? " bg-blue-800 " : "bg-[#00000030] "
                          } py-1  px-3 text-xs text-white rounded-lg`}
                        >
                          {" "}
                          {OTPSent ? "Sent" : "Get"}
                        </div>
                      </div>
                      <div className="relative">
                        <input
                          type="text"
                          value={OTP}
                          onChange={(e) => {
                            if (e.target.value.length <= 6) {
                              setOTP(e.target.value);
                              if (e.target.value.length == 6)
                                verifyOTP(e.target.value);
                            }
                          }}
                          placeholder="OTP"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                          required
                        />
                        <div
                          className={`cursor-pointer absolute bottom-1 right-2 ${
                            OTPVerified ? "text-green-500" : "text-red-500"
                          } py-1  px-3  text-white rounded-lg `}
                        >
                          {" "}
                          {OTPVerified ? (
                            <BsCheckAll size={25} />
                          ) : (
                            <RxCross1 size={25} />
                          )}
                        </div>
                      </div>

                      <div className="text-white">
                        <label className="block mb-2 text-sm text-left font-medium text-white dark:text-white">
                          Card Information
                        </label>
                        <div className="bg-white p-2">
                          <CardElement className="" />
                        </div>
                      </div>

                      <div className="text-blue-200">
                        <label className="flex gap-1 items-center">
                          <input
                            type="checkbox"
                            disabled={!checkTerms}
                            className="block text-sm text-left font-medium"
                            checked={checkTerms}
                          />

                          <label
                            onClick={openTermsModal}
                            className="block my-2 cursor-pointer text-sm text-left font-medium"
                          >
                            Accept Terms & Conditions*
                          </label>
                        </label>
                      </div>

                      <button
                        type="submit"
                        className={`w-full text-white  focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${
                          name && phone && email && checkTerms && OTPVerified
                            ? "bg-blue-800"
                            : "bg-blue-300"
                        } dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800`}
                        disabled={
                          !name ||
                          !phone ||
                          !checkTerms ||
                          !email ||
                          !OTPVerified
                        }
                      >
                        Pay
                      </button>
                    </form>
                    <Loading isLoading={isLoading} />
                  </div>
                </div>
              </div>
              <button
                onClick={props.modalFiatClose}
                type="button"
                className="mx-4 my-2 w-[90%] text-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 "
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {showTermsModal ? (
        <TermsnConditions
          modalTermsClose={() => {
            openTermsModal();
          }}
          button="Accept Terms & Conditions"
          check={checkTermsHandel}
        />
      ) : (
        ""
      )}
    </>
  );
};
const StripePaymentForm = (props) => {
  return (
    <Elements stripe={stripePromise}>
      <Fiat modalFiatClose={props.modalFiatClose} />
    </Elements>
  );
};

export default StripePaymentForm;
